import React, { useContext, useEffect, useState } from "react";
import {
  Typography,
} from "@mui/material";
import i18next from "i18next";

import { Context } from "../../../../../states/Store";
import { ERROR } from "../../../../../services/common/Constants";
import EADialog from "../../../../../components/common/EADialog";
import EAIcon from "../../../../../components/common/EAIcon";
import useStyles from "./DossierModelDialogStyle";
import { useRequestLoading } from "../../../../../components/common/hooks/useRequestLoading";
import { deleteMultipleDossierModel } from "services/edge/DossierModelService";
import { Trans } from 'react-i18next';
import clsx from "clsx";
import { partition as lodashPartition} from "lodash";

const DossierModelDeleteDialog = ({
  isOpen,
  modelList,
  onClose,
  onValidateSuccess,
}) => {
  const { classes } = useStyles();
  const { isRequestLoading, startLoading, stopLoading } = useRequestLoading();
  const [state, dispatch] = useContext(Context);

  const handleDelete = async () => {
    try {
      startLoading();
      let filteredModelList = modelList.filter(m => !m.associatedToDossiers);
      const label = filteredModelList?.[0]?.libelle;
      const message = filteredModelList?.length > 1
        ? i18next.t(`demandes.dossierModel.notifications.deletedMulti`)
        : <Trans i18nKey="demandes.dossierModel.notifications.deleted">Le modèle "<span style={{ fontWeight: "bold" }}>{{label}}</span>" a bien été supprimé.</Trans>

      await deleteMultipleDossierModel(state.account.id, filteredModelList.map(m => m.id), null);

      dispatch({
        type: "ALERT",
        alert: { type: ERROR, msg: message }
      });

      onValidateSuccess();
    } catch (error) {
      dispatch({ type: "ALERT", alert: { type: ERROR, msg: "DELETE_ERROR" } });
    } finally {
      stopLoading();
    }
  };

  return (
    <EADialog
      isOpen={isOpen}
      onCancel={onClose}
      onValidate={handleDelete}
      hasActions={true}
      maxWidth="popupxs"
      fullWidth
      variant="redValid"
      btnSize="large"
      isValidateDisabled={isRequestLoading}
    >
      {modelList && (
        <>
          <div className={classes.root}>
            <div className={classes.imgWrapper}>
              <EAIcon icon={"delete_red"} className={classes.imgContent} />
            </div>
            {modelList?.length === 1 ?
              <span className={classes.bolder}>
                {i18next.t("demandes.dossierModel.deleteDialog.title", { status: modelList[0]?.active ? i18next.t("demandes.dossierModel.status.options.active").toLocaleLowerCase() : i18next.t("demandes.dossierModel.status.options.inactive").toLocaleLowerCase() })}
              </span>
              : <span className={classes.bolder}>
                {i18next.t("demandes.dossierModel.deleteDialog.titleMulti")}
              </span>}
          </div>

          <div>
            <InfoBloc modelList={modelList} />
          </div>
        </>
      )}
    </EADialog>
  );
}

const InfoBloc = ({ modelList }) => {
  const { classes } = useStyles();
  const [state, ] = useContext(Context);
  const [usedModel, setUsedModel] = useState([]);
  const [unusedModel, setUnusedModel] = useState([]);

 useEffect(() => {
    if (state.account && modelList) {
      const [cannotDelete, toDelete] = lodashPartition(modelList, 'associatedToDossiers');
      setUnusedModel(toDelete);
      setUsedModel(cannotDelete);
    }
  }, [state.account, modelList]);

  return (
    <div className={classes.modelInfoBlocWrapper}>
          <div className={classes.modelInfoCaption}>
            <EAIcon icon={"delete_red"} className={classes.imgContent} />
            <Typography style={{ fontWeight: "bold" }}>{i18next.t("demandes.dossierModel.deleteDialog.confirm")}</Typography>
          </div>
          {unusedModel?.map((modelDossier) => (
            <Typography key={modelDossier.id} className={clsx(classes.dt, classes.modelInfoBlocContent)}>
              {modelDossier.libelle}
            </Typography>
          ))}
          {usedModel.length > 0 && (
            <>
            <span className={classes.activeModelSubtitle}>
                {i18next.t("demandes.dossierModel.deleteDialog.caption")}
              </span>
          {usedModel?.map((modelDossier) => (
            <Typography key={modelDossier.id} className={clsx(classes.dt, classes.modelInfoBlocContent)}>
              {modelDossier.libelle}
            </Typography>
          ))}
          </>
        )}
    </div>
  )
};


export default DossierModelDeleteDialog;
